import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { Theme } from "./theme.model";
import { handleError } from "../shared/handle-error";

@Injectable()
export class ThemeService {
    private themesUrl = "api/themes";  // url to web api
    private _activeTheme: Theme;

    constructor(private http: HttpClient) {
        this._activeTheme = JSON.parse(localStorage.getItem("active_theme"));
    }

    get primaryColour(): string {
        return (this._activeTheme
            && this._activeTheme.primaryColour)
            ? this._activeTheme.primaryColour
            : null;
    }

    get navbarLogo(): string {
        return (this._activeTheme
                && this._activeTheme.navbarLogo
                && this._activeTheme.navbarLogo.fileContentBase64)
            ? `data:image/png;base64,${this._activeTheme.navbarLogo.fileContentBase64}`
            : null;
    }

    private set activeTheme(value: Theme) {
        // save to localStorage incase user refreshes the browser
        localStorage.setItem("active_theme", JSON.stringify(value))
        this._activeTheme = value;
    }

    getTheme(): Promise<Theme> {
        return this.http.get<Theme>(this.themesUrl)
            .toPromise()
            .then(theme => {
                this.activeTheme = theme;
                return theme;
            })
            .catch(handleError);
    }

    removeActiveTheme(): void {
        localStorage.removeItem("active_theme");
        this._activeTheme = null;
    }

    update(theme: Theme): Promise<void> {
        return this.http.post(this.themesUrl, theme)
            .toPromise()
            .then(() => {
                // only replace the whole theme object if user attempted to upload a logo as part of the form submission,
                // to prevent the current logo from disappearing.
                if (theme.navbarLogo != null) {
                    this.activeTheme = theme;
                } else {
                    this._activeTheme.primaryColour = theme.primaryColour;
                }
            })
            .catch(handleError);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/core/theme.service.ts